"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelView = void 0;
var foundation_1 = require("@deqo/foundation");
var ModelSnapshotView = /** @class */ (function () {
    function ModelSnapshotView(snapshot) {
        this.snapshot = snapshot;
    }
    ModelSnapshotView.prototype.getVersion = function () {
        return this.snapshot.version;
    };
    ModelSnapshotView.prototype.getList = function () {
        return Object.keys(this.snapshot.instances);
    };
    ModelSnapshotView.prototype.getInfo = function (entityId) {
        this.assertExists(entityId);
        return this.snapshot.instances[entityId];
    };
    ModelSnapshotView.prototype.exists = function (entityId) {
        return !!this.snapshot.instances[entityId];
    };
    ModelSnapshotView.prototype.getStateValue = function (entityId, key) {
        var _a;
        this.assertExists(entityId);
        return (_a = this.snapshot.states[entityId][key]) !== null && _a !== void 0 ? _a : null;
    };
    ModelSnapshotView.prototype.getState = function (entityId) {
        this.assertExists(entityId);
        return this.snapshot.states[entityId];
    };
    ModelSnapshotView.prototype.getParent = function (entityId) {
        this.assertExists(entityId);
        return this.snapshot.parentLinks[entityId];
    };
    ModelSnapshotView.prototype.getChildren = function (entityId) {
        this.assertExists(entityId);
        return this.snapshot.childLinks[entityId];
    };
    ModelSnapshotView.prototype.assertExists = function (entityId) {
        (0, foundation_1.assert)(this.exists(entityId), "ModelSnapshotView: ".concat(entityId, " does not exist."));
    };
    return ModelSnapshotView;
}());
exports.ModelView = Object.freeze({
    /**
     * Creates a ModelView that exposes the data in the specified snapshot.
     *
     * @param snapshot
     */
    create: function (snapshot) {
        return new ModelSnapshotView(snapshot);
    }
});
